import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';
import { push } from 'connected-react-router';

import { UPLOAD_SCORE_CARD } from '../types/scoreCardTypes';
import { uploadScoreCardFulfilled, uploadScoreCardPending, uploadScoreCardRejected } from '../actions/uploadScoreCardActions';
import { sendApiRequest } from '../../../actions/apiRequestActions';
import { notifyError, notifySuccess } from '../../../actions';
import { SCORE_CARD_MESSAGES } from '../constants/scoreCardMessages';
import generateError from '../../../utilities/generateError';
import routesConfig from '../../../routes/routes-config';

const uploadPayload = payload => ({
  method: 'post',
  url: 'scorecard/upload',
  onSuccess: [
    uploadScoreCardFulfilled,
    () => notifySuccess(SCORE_CARD_MESSAGES.CREATED),
    () => push(routesConfig.scoreCardOperationsPage.path),
  ],
  onError: [
    uploadScoreCardRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
  amlJava:true,

});

const meta = {
  api: 'formDataApi',
};

const uploadScoreCardEpic$ = action$ => action$.pipe(
  ofType(UPLOAD_SCORE_CARD.DEFAULT),
  mergeMap(({ payload }) => merge(
    of(uploadScoreCardPending()),
    of(sendApiRequest(uploadPayload(payload), meta)),
  )),
);

export default uploadScoreCardEpic$;


// WEBPACK FOOTER //
// ./src/features/score-card/epics/uploadScoreCardEpic.js